import { atribuirNomesEntidades, filterAcessosPorSistema, agruparAcessosPorEntidade, encodeIdSistemas, isContextoPrincipal } from "./contexto-utils";

export default function AcessoService($http, $q, userAccountsUtil, userAccountsService, licencaService) {

  const getAcessosAgrupadosPorEntidade = () => meusAcessos()
    .then(agruparAcessosPorEntidade)
    .then(atribuirNomesEntidades(userAccountsService));

  const getAcessosBySistema = (sistema) => meusAcessos()
    .then(data => filterAcessosPorSistema(data, sistema));

  const minhasEntidades = () => {
    return userAccountsService.myContexts().then((contextList) => {
      const entities = contextList;
      const ids = _.map(contextList, getIds);
      return this.entitiesInfo(ids).then(function (infos) {
        _.forEach(infos, function (info) {
          _.find(entities, function (entity) { return entity.entity == info.id; }).name = info.name;
        });
        return _.sortBy(entities, 'name');;
      });
    });
  };

  const getSistemasByEntidade = (entidade) => {
    return meusAcessos()
      .then(acessos => _(acessos)
        .filter(acesso => acesso.values.entity == entidade)
        .map(acesso => acesso.system)
        .value())
      .then(licencaService.getSistemas)
      .then(sistemas => encodeIdSistemas(sistemas));
  };

  const meusSistemas = (contexto) => {
    return $http.get(userAccountsUtil.urlNewUserAccounts(`suite/users/@me/access/${context}/systems?includeCurrentAsSourceSystem=true`))
      .then(function (response) {
        return response.data;
      });
  };

  const meusAcessos = () => {
    return $http.get(userAccountsUtil.urlNewUserAccounts('suite/users/@me/access?includeCurrentAsSourceSystem=true'))
      .then((response) => {
        return _.filter(response.data, acesso => acesso.admin);
      });
  };

  const meusAcessosPorSubcontexto = () => {
    return $http.get(userAccountsUtil.urlNewUserAccounts('suite/@me/access/contexts?includeCurrentAsSourceSystem=true'))
      .then(response => _(response.data)
        .forEach(subcontexto => {
          subcontexto.accesses = _.filter(subcontexto.accesses, acesso => acesso.admin);
        })
        .value());
  };

  const getAcesso = (contexto) => {
    return $http.get(userAccountsUtil.urlNewUserAccounts(`suite/users/@me/access/${contexto}`))
      .then((response) => {
        const acessos = response.data;
        if (_.isEmpty(acessos)) {
          return $q.reject();
        }

        const acessoContexto = _.find(acessos, acesso => acesso.context === contexto);
        if (acessoContexto) {
          return acessoContexto;
        }

        const acessoPrincipal = _.find(acessos, acesso => isContextoPrincipal(acesso.values));
        return acessoPrincipal || acessos[0];
      });
  };

  return {
    getAcessosAgrupadosPorEntidade,
    getAcessosBySistema,
    minhasEntidades,
    getSistemasByEntidade,
    meusSistemas,
    meusAcessos,
    meusAcessosPorSubcontexto,
    getAcesso
  };
}

AcessoService.$inject = [
  '$http', '$q', 'UserAccountsUtil', 'UserAccountsService', 'LicencaService'
];
